export const MIN_VALIDATION_GREMLIN_VERSION_LINUX = '2.22.0'
export const MIN_VALIDATION_GREMLIN_VERSION_WINDOWS = '1.5.0'

// We needed to know what client versions are considered "new" for the onboarding dashboard
// This version number comes from Phil. 2.13.0 or higher is new
// The team is looking into a way to add this information to an endpoint so we don't have to hardcode it like this
export const NEW_CLIENT_VERSION_MIN = [2, 13, 0]
export const NEW_WINDOWS_CLIENT_VERSION_MIN = [1, 0, 6]
export const MIN_VALIDATION_CHAO_CLIENT_VERSION = '0.4.2'

export function getClientVersion(target) {
  return target.alfi_version || (target?.tags ?? {})['gremlin-client-version']
}

export function getClientVersionArray(version) {
  if (!version) return null
  return version.split('.').map((part) => Number(part))
}

export function isOlderClientVersion(clientVersionArray, newerVersion) {
  if (clientVersionArray === null) return false
  if (!Array.isArray(clientVersionArray) || clientVersionArray.length < 1) {
    return true
  }

  for (let i = 0; i < clientVersionArray.length; i++) {
    if (clientVersionArray[i] < newerVersion[i]) {
      return true
    } else if (clientVersionArray[i] > newerVersion[i]) {
      return false
    }
  }
  return false
}

export function getLowestClientVersion(clients) {
  if (!clients || !Array.isArray(clients) || clients.length < 1) {
    return null
  }

  // start with a min at 100
  let minVersion = [100000, 0, 0]
  clients.forEach((target) => {
    const clientVersionArray = getClientVersionArray(getClientVersion(target))
    // if the current version is newer than the max then assign the max to it
    // loop through until the end of the versions array
    if (
      isOlderClientVersion(clientVersionArray, minVersion) &&
      clientVersionArray
    ) {
      minVersion = clientVersionArray
    }
  })

  // if none of the clients had versions then return null
  if (minVersion.join('.') === '100000.0.0') {
    return null
  }

  return minVersion.join('.')
}

export function getHighestClientVersion(clients) {
  if (!clients || !Array.isArray(clients) || clients.length < 1) {
    return null
  }

  // start with a max at 0
  let maxVersionArray = [0, 0, 0]
  clients.forEach((target) => {
    const clientVersionArray = getClientVersionArray(getClientVersion(target))
    // if the current version is newer than the max then assign the max to it
    // loop through until the end of the versions array
    if (
      !isOlderClientVersion(clientVersionArray, maxVersionArray) &&
      clientVersionArray
    ) {
      maxVersionArray = clientVersionArray
    }
  })

  // if none of the clients had versions then return null
  if (maxVersionArray.join('.') === '0.0.0') {
    return null
  }

  return maxVersionArray.join('.')
}
